var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolDataTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.9999 50.0024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "d",
    className: "e",
    d: "m23.8274.0274C10.0374.6773-.6126,12.3873.0274,26.1773c.61,12.8799,10.9199,23.1899,23.8,23.8003,13.83.6099,25.5399-10.1104,26.1499-23.9399.03-.7402.03-1.4702,0-2.2104C49.3274,10.0377,37.6274-.6127,23.8274.0274Zm16.83,35.0103c0,3.0996-2.52,5.6196-5.62,5.6196H14.9673c-3.11,0-5.6199-2.52-5.6199-5.6196V14.9674c0-3.1001,2.5099-5.6201,5.6199-5.6201h20.0701c3.1,0,5.62,2.52,5.62,5.6201v20.0703Zm-9.63,3.1797h4.01c1.75,0,3.1799-1.4297,3.1799-3.1797v-4.0103h-7.1899v7.1899Zm0-9.6401h7.1899v-7.1499h-7.1899v7.1499Zm4.01-16.7896h-4.01v7.1899h7.1899v-4.0103c0-1.75-1.4299-3.1797-3.1799-3.1797Zm-13.62,26.4297h7.16v-7.1899h-7.16v7.1899Zm0-9.6401h7.16v-7.1499h-7.16v7.1499Zm0-9.5996h7.16v-7.1899h-7.16v7.1899Zm-9.63,16.0601c0,1.75,1.4299,3.1797,3.1799,3.1797h4.01v-7.1899h-7.1899v4.0103Zm0-6.4604h7.1899v-7.1499h-7.1899v7.1499Zm0-13.6099v4.0103h7.1899v-7.1899h-4.01c-1.75,0-3.1799,1.4297-3.1799,3.1797Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDataTable);
export default __webpack_public_path__ + "static/media/symbol-data-table.1b4af6a30bff458522b9c5bf58c283be.svg";
export { ForwardRef as ReactComponent };